/**
 * Returns the percentage of the value in relation to the total, with a maximum of 100.
 * @param value
 * @param total
 */
export const getProgressPercentage = (value: number, total: number) => {
	if (total === 0) {
		return 0;
	}
	return Math.min(Math.round(value / total * 100), 100);
};
